import { Coupon } from './coupon';
import { Plan } from './plan';
import { Subscription } from './subscription';
import { User } from './user';

export type Billing = {
  billing_id: number;
  imp_uid?: string;
  merchant_uid?: string;
  customer_uid?: string;
  amount?: number;
  currency: string;
  pay_method?: string;
  status: string;
  billing_date?: Date;
  pg_provider?: string;
  card_number?: string;
  card_name?: string;
  bank_name?: string;
  pg_tid?: string;
  receipt_url?: string;
  fail_reason?: string;
  failed_at?: Date;
  created_at: Date;
  updated_at: Date;
  card_quota: number;

  plan?: Plan;
  user?: User;
  coupon?: Coupon;
  subscription?: Subscription;
  expired_at?: Date;
};

export type PaymentDto = {
  success?: boolean;
  imp_uid?: string | null;
  pay_method?: string;
  merchant_uid: string;
  name: string;
  paid_amount: number;
  pg_provider?: string;
  pg_type?: string;
  pg_tid?: string;
  apply_num?: string;
  buyer_name?: string;
  buyer_email?: string;
  buyer_tel?: string;
  buyer_addr?: string;
  buyer_postcode?: string;
  custom_data?: string;
  status?: string;
  paid_at: number;
  receipt_url?: string;
  card_name?: string;
  card_quota?: number;
};

export enum PAYMENT_CUSTOM_DATA_ACTION {
  RESERVE = 'reserve',
  SUBSCRIBE = 'subscribe',
  CHANGE_PLAN = 'change_plan',
  CHANGE_BILLING_METHOD = 'change_billing_method',
}

export type PaymentCancelDto = {
  imp_uid?: string;
  merchant_uid?: string;
  amount?: number;
  tax_free?: number;
  vat_amount?: number;
  checksum?: number;
  reason?: string;
  refund_holder?: string;
  refund_bank?: string;
  refund_account?: string;
  refund_tel?: string;
  extra?: any[];
};
